import React from "react";
import { motion } from "framer-motion";

const FiltersPanel = ({ filters, setFilters, uniqueForms }) => {
  // ✅ Match Firebase Image: pending, resolved, unresolved
  const STATUS_OPTIONS = ["pending", "resolved", "unresolved"];

  // ✅ Match Firebase Metadata: normal, high
  const PRIORITY_OPTIONS = ["normal", "high"];

  const CATEGORY_OPTIONS = [
    "Technical Support",
    "General Inquiry",
    "Billing",
    "Bug Report",
  ];

  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: "auto", opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      className="overflow-hidden mb-6"
    >
      <div className="bg-white p-6 rounded-[24px] shadow-sm border border-gray-100 grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* 1. Category Filter */}
        <div>
          <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">
            Category
          </label>
          <select
            value={filters.category}
            onChange={(e) =>
              setFilters((p) => ({ ...p, category: e.target.value }))
            }
            className="w-full px-4 py-3 bg-gray-50 border border-gray-100 rounded-xl text-xs font-bold text-gray-700 outline-none focus:border-[#0B1C2D] transition-all"
          >
            <option value="ALL">All Categories</option>
            {CATEGORY_OPTIONS.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>

        {/* 2. Status Filter */}
        <div>
          <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">
            Ticket Status
          </label>
          <select
            value={filters.status}
            onChange={(e) =>
              setFilters((p) => ({ ...p, status: e.target.value }))
            }
            className="w-full px-4 py-3 bg-gray-50 border border-gray-100 rounded-xl text-xs font-bold text-gray-700 outline-none focus:border-[#0B1C2D] transition-all"
          >
            <option value="ALL">All Statuses</option>
            {STATUS_OPTIONS.map((status) => (
              <option key={status} value={status}>
                {status.toUpperCase()}
              </option>
            ))}
          </select>
        </div>

        {/* 3. Priority Filter */}
        <div>
          <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">
            Priority Level
          </label>
          <select
            value={filters.priority}
            onChange={(e) =>
              setFilters((p) => ({ ...p, priority: e.target.value }))
            }
            className="w-full px-4 py-3 bg-gray-50 border border-gray-100 rounded-xl text-xs font-bold text-gray-700 outline-none focus:border-[#0B1C2D] transition-all"
          >
            <option value="ALL">All Priorities</option>
            {PRIORITY_OPTIONS.map((prio) => (
              <option key={prio} value={prio}>
                {prio.toUpperCase()}
              </option>
            ))}
          </select>
        </div>

        {/* 4. Subject/Source Filter */}
        <div>
          <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">
            Inquiry Subject
          </label>
          <select
            value={filters.formTitle}
            onChange={(e) =>
              setFilters((p) => ({ ...p, formTitle: e.target.value }))
            }
            className="w-full px-4 py-3 bg-gray-50 border border-gray-100 rounded-xl text-xs font-bold text-gray-700 outline-none focus:border-[#0B1C2D] transition-all"
          >
            <option value="ALL">All Subjects</option>
            {uniqueForms.map((title, i) => (
              <option key={i} value={title}>
                {title}
              </option>
            ))}
          </select>
        </div>
      </div>
    </motion.div>
  );
};

export default FiltersPanel;
